export default __webpack_public_path__ + "static/media/Consultation-Charges.c3901702.svg";